// extracted by mini-css-extract-plugin
export var carrierIcon = "_yi-0";
export var carrierLogo = "_yi-1";
export var detailsSection = "_yi-2";